import { render, staticRenderFns } from "./enterpriseDepartment-add-or-update.vue?vue&type=template&id=05be6800&scoped=true&"
import script from "./enterpriseDepartment-add-or-update.vue?vue&type=script&lang=js&"
export * from "./enterpriseDepartment-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseDepartment-add-or-update.vue?vue&type=style&index=0&id=05be6800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05be6800",
  null
  
)

export default component.exports